import { BhAppointmentDto } from '@act/shared/data-transfer-objects';
import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { feedSlice, getFeedItems } from 'redux/slices/feedSlice.slice';
import { resetRedux } from '../actions/sharedActions';
import { useAppSelector } from '../storeHooks';
import { getAlertsForMemberFeed } from 'redux/slices/alertSlice.slice';

const bhAppointmentsAdapter = createEntityAdapter<BhAppointmentDto>();

const initialState = {
  bhAppointments: bhAppointmentsAdapter.getInitialState(),
};

export const bhAppointmentsSlice = createSlice({
  name: 'bhAppointments',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(resetRedux, () => ({ ...initialState }))
      .addCase(feedSlice.actions.feedItemUpdated, (state, action) => {
        const rows = action.payload.feedItemModelView.bhAppointments;
        if (!rows?.length) return;
        bhAppointmentsAdapter.upsertMany(state.bhAppointments, rows);
      })
      .addCase(getFeedItems.fulfilled, (state, action) => {
        const rows = action.payload.bhAppointments;
        if (!rows?.length) return;
        bhAppointmentsAdapter.upsertMany(state.bhAppointments, rows);
      })
      .addCase(getAlertsForMemberFeed.fulfilled, (state, action) => {
        const rows = action.payload.bhAppointments;
        if (!rows?.length) return;
        bhAppointmentsAdapter.upsertMany(state.bhAppointments, rows);
      });
  },
});

export const bhAppointmentsReducer = bhAppointmentsSlice.reducer;

const selectBhAppointmentsSliceState = state =>
  (state as { bhAppointments: typeof initialState })?.bhAppointments;

const selectBhAppointmentsEntityState = state =>
  selectBhAppointmentsSliceState(state).bhAppointments;

const { selectById: selectBhAppointmentById } =
  bhAppointmentsAdapter.getSelectors(selectBhAppointmentsEntityState);

export const bhAppointmentsSliceSelectors = {
  useSelectBhAppointmentById: (id: number) =>
    useAppSelector(state => selectBhAppointmentById(state, id)),
};
